<nav>
  <div class="logo">
    <a routerLink="/home"><img src="../../../../assets/images/studenty.png" alt="Pikoro" /></a>
  </div>

  <ul class="nav-links">
    <li><a routerLink="/home" routerLinkActive="active">Home</a></li>
    <li><a href="/home/posts" routerLinkActive="active">Marketplace</a></li>
    <li><a href="/home/clubsdata" routerLinkActive="active">Clubs</a></li>
    <li><a href="/home/events" routerLinkActive="active">Events</a></li>
    <li><a href="/home/calendar" routerLinkActive="active">Calendar</a></li>
    
    <li><a href="/home/opportunities" routerLinkActive="active">Opportunities</a></li>
    <li>
      <div class="slim-header-right"></div>
    </li>
    <li [hidden]="hideLogin">
      <img class="log-in-logo" style="width: 30px; height: 30px" src="../../assets/images/Vector.png" />
      <a class="log-in-logo" style="font-weight: bold; color: #2D2F44; margin-left: 0px; margin-bottom: 10px;" routerLink="/home/login">Log in</a>
    </li>
    <li [hidden]="hideLogout">
      <a href="/home/profile">
        <img routerLink="/home/profile" src="http://localhost:9091/User/{{ profileImage }}" style="
            width: 50px;
            height: 50px;
            border-radius: 50%;
            border: 2px solid #2D2F44;
            display: inline;
            margin-right: 0px;
          "
          alt=""
      /></a>
      <a
        routerLink="/home/profile"
        
        style="
          font-weight:lighter;
          display: inline;
          color: #2D2F44;
          margin-left: 0px;
          font-size:17px;
          margin-bottom: 10px;
        "
      >
        <i class="ion-md-power"></i>
        &nbsp;{{user.nom}}
      </a>
      <a
        routerLink="/home/login"
        class="nav-link"
        style="
          font-weight: lighter;
          display: inline;
          color: #2D2F44;
          margin-left: 0px;
          margin-bottom: 10px;
          font-size:17px;
        "
        (click)="logout()"
      >
        <i class="ion-md-power"></i>
        &nbsp;Logout
      </a>
    </li>
  </ul>
</nav>

<input type="checkbox" id="active">
<label for="active" class="menu-btn"><span></span></label>
<label for="active" class="close"></label>
<div class="wrapper">
  <ul>
    <li [hidden]="hideLogin">
      <img class="log-in-logo" style="width: 30px; height: 30px" src="../../assets/images/Vector.png" />
      <a class="log-in-logo" style="font-weight: bold; color: #2D2F44; margin-left: 0px; margin-bottom: 10px;" routerLink="/home/login">Log in</a>
    </li>
    <li [hidden]="hideLogout">
      <a href="/home/profile">
        <img routerLink="/home/profile" src="http://localhost:9091/User/{{ profileImage }}" style="
            width: 50px;
            height:50px;
border-radius: 50%;
margin: auto;
border: 2px solid #2D2F44;
display: inline;
"
alt=""
/></a>
<a
routerLink="/home/login"
class="nav-link"
style="
font-weight: bold;
display: inline;
color: #2D2F44;
margin-left: 0px;
margin-bottom: 10px;
"
(click)="logout()"
>
<i class="ion-md-power"></i>
&nbsp;Logout
</a>
</li>
<li><a routerLink="/home" routerLinkActive="active">Home</a></li>
<li><a routerLink="/home/howitwork" routerLinkActive="active">How it works</a></li>
<li><a routerLink="/home/events" routerLinkActive="active">Events</a></li>
<li><a routerLink="/home/blogs" routerLinkActive="active">Blog</a></li>
<li><a routerLink="/home/partnership" routerLinkActive="active">Partnership</a></li>
<li><a routerLink="/home/contact" routerLinkActive="active">Get in touch</a></li>
<li>
<div class="slim-header-right"></div>
</li>
</ul>
</div>